import { ofType } from 'redux-observable'
import { from, of } from 'rxjs'
import { switchMap, catchError } from 'rxjs/operators'
import { fetchRvuReportSuccess, fetchRvuReportError } from './rvuReport.actions'
import { FETCH_RVU_REPORT } from './rvuReport.types'
import { getRvuReport } from './rvuReport.service'

const fetchRvuReportEpic = (action$) =>
  action$.pipe(
    ofType(FETCH_RVU_REPORT),
    switchMap((action) =>
      from(getRvuReport(action.payload)).pipe(
        switchMap((response) => of(fetchRvuReportSuccess(response))),
        catchError((error) =>
          of(fetchRvuReportError(error?.message || 'API Error')),
        ),
      ),
    ),
  )

export default {
  fetchRvuReportEpic,
}
